import React from 'react';
import { CloseButton, Modal } from 'react-bootstrap';
import './CommonModal.scss';

const CommonModal = (props) => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        centered
        backdropClassName={props.backdropClassName}
        className={`${props.className} ${props.variant} commonModal nondraggable_card`}
        backdrop={props?.backdrop}
      >
        <div onClick={props.handleClose} className="modal_close_btn">
          <CloseButton disabled={props.disableClose} />
        </div>
        {props.heading && (
          <Modal.Header>
            {props.eyebrow ? (
              <span className="commonModal__eyebrow">{props.eyebrow}</span>
            ) : null}
            <Modal.Title>
              <h4>{props.heading}</h4>
            </Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>{props?.children}</Modal.Body>
      </Modal>
    </>
  );
};

export default CommonModal;
